export const GRADE_STYLES = {
  "A+": { bg: "rgba(16,185,129,0.14)", color: "#10B981", border: "rgba(16,185,129,0.4)" },
  "A": { bg: "rgba(16,185,129,0.14)", color: "#10B981", border: "rgba(16,185,129,0.4)" },
  "B+": { bg: "rgba(59,130,246,0.14)", color: "#3B82F6", border: "rgba(59,130,246,0.4)" },
  "B": { bg: "rgba(59,130,246,0.14)", color: "#3B82F6", border: "rgba(59,130,246,0.4)" },
  "C+": { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", border: "rgba(245,158,11,0.4)" },
  "C": { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", border: "rgba(245,158,11,0.4)" },
  "D": { bg: "rgba(239,68,68,0.14)", color: "#EF4444", border: "rgba(239,68,68,0.4)" },
};

export const STATUS_STYLES = {
  "Pending": { bg: "rgba(100,116,139,0.14)", color: "#94A3B8", border: "rgba(100,116,139,0.4)" },
  "In Progress": { bg: "rgba(14,165,233,0.14)", color: "#38BDF8", border: "rgba(14,165,233,0.4)" },
  "Submitted": { bg: "rgba(139,92,246,0.14)", color: "#A78BFA", border: "rgba(139,92,246,0.4)" },
  "Under Review": { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", border: "rgba(245,158,11,0.4)" },
  "Completed": { bg: "rgba(16,185,129,0.14)", color: "#10B981", border: "rgba(16,185,129,0.4)" },
  "Delayed": { bg: "rgba(239,68,68,0.14)", color: "#EF4444", border: "rgba(239,68,68,0.4)" },
  "On Time": { bg: "rgba(16,185,129,0.14)", color: "#10B981", border: "rgba(16,185,129,0.4)" },
  "Buffer Absorbed": { bg: "rgba(245,158,11,0.14)", color: "#F59E0B", border: "rgba(245,158,11,0.4)" },
};

export const CONTENT_STATUSES = ["Pending", "In Progress", "Submitted", "Under Review", "Completed", "Delayed"];
export const DEV_STATUSES = ["Pending", "In Progress", "Under Review", "Completed", "Delayed"];

export function scoreColor(score) {
  if (score >= 90) return "#10B981";
  if (score >= 70) return "#3B82F6";
  if (score >= 50) return "#F59E0B";
  return "#EF4444";
}

export const GRADE_SCALE = [
  { grade: "A", range: "90–100%", label: "Excellent", color: "#10B981" },
  { grade: "B", range: "70–90%", label: "Good", color: "#3B82F6" },
  { grade: "C", range: "50–70%", label: "Bad", color: "#F59E0B" },
  { grade: "D", range: "Under 50%", label: "Worst", color: "#EF4444" },
];
